import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { QueryProvider } from './providers/QueryProvider'
import { pwaService } from './services/pwaService'
import './index.css'

// Initialize PWA functionality
const initializePWA = async () => {
  try {
    await pwaService.initialize()
    console.log('[PWA] Initialization completed')
  } catch (error) {
    console.error('[PWA] Initialization failed:', error)
  }
}

// Start PWA initialization
initializePWA()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>,
)